import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgCaretRight = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      fillOpacity={0.12}
      d="m13.267 7.231 4.5 4.5a.45.45 0 0 1 0 .637l-4.5 4.5a.45.45 0 1 1-.637-.637l4.182-4.181-4.182-4.182a.45.45 0 1 1 .637-.637"
    />
    <path
      fill="#FF4406"
      d="m6.067 7.231 4.5 4.5a.45.45 0 0 1 0 .637l-4.5 4.5a.45.45 0 1 1-.636-.637l4.182-4.181L5.43 7.868a.45.45 0 0 1 .636-.637"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCaretRight);
export default ForwardRef;
